import {
    DataLoadedAction,
    ErrorLoadingDataAction,
    LoadingDataAction,
    SetTimeAction,
    TemplateLoadedAction,
    TypeKeys,
} from '../../state-management/widgetblock/actions/types';
import { Dataset, SingleCurrentValueConfigBlockState, SingleCurrentValueState } from './types';
import mergeTemplateAndData, { RequiredSingleCurrentValueState } from './utils/mergeTemplateAndData';

type Actions =
    | LoadingDataAction
    | TemplateLoadedAction<SingleCurrentValueConfigBlockState>
    | ErrorLoadingDataAction
    | SetTimeAction
    | DataLoadedAction<Dataset[]>;

const INITIAL_STATE: SingleCurrentValueState = {
    datasets: null,
    viewblockState: null,
};

const checkIfEverythingLoaded = ({ datasets, viewblockState, time }: SingleCurrentValueState) => Boolean(datasets && viewblockState && time);

const checkIfEverythingLoadedAndRunFunc = (state: SingleCurrentValueState, func: (state: RequiredSingleCurrentValueState) => SingleCurrentValueState) =>
    checkIfEverythingLoaded(state) ? func(state as RequiredSingleCurrentValueState) : state;

const reducer = (state = INITIAL_STATE, action: Actions) => {
    switch (action.type) {
        case TypeKeys.LOADING_DATA:
            return { ...state, isLoadingData: true };

        case TypeKeys.ERROR_LOADING_DATA:
            return { ...state, isLoadingData: false };

        case TypeKeys.SET_TIME: {
            const { iso8601, timezone } = action.payload;

            return checkIfEverythingLoadedAndRunFunc({ ...state, time: { iso8601, timezone } }, mergeTemplateAndData);
        }

        case TypeKeys.TEMPLATE_LOADED:
            return checkIfEverythingLoadedAndRunFunc({ ...state, viewblockState: action.payload.data }, mergeTemplateAndData);

        case TypeKeys.DATA_LOADED:
            return checkIfEverythingLoadedAndRunFunc({ ...state, datasets: action.payload.data, isLoadingData: false }, mergeTemplateAndData);

        default:
            return state;
    }
};

export default reducer;
